module.exports = __webpack_public_path__ + "media/images/weather/258_night-5d13bd68158109c8366563c2534ce00d.png";